import React from 'react';
import PropTypes from 'prop-types';
import { EmailAddress, useFormValidation, CircleButton, Typography } from '../../index';
import "./email_form.scss";

export const EmailForm = ({
    customValidation,
    disabled = false,
    errorMsg,
    hintMsg,
    id,
    label,
    name,
    onBlur = () => { },
    onChange = () => { },
    onSubmit = () => { },
    pattern,
    required = true,
    value,
    ...inputProps
}) => {
    const emailAddressPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;    //basic email regex

    const validationRules = {
        [name]: {
            required: {
                value: required,
                message: errorMsg
            },
            pattern: {
                value: pattern ? pattern : emailAddressPattern,
                message: errorMsg
            },
            custom: {
                isValid: customValidation,
                message: errorMsg
            }
        }
    };

    const { handleForm, handleInput, formErrors } = useFormValidation({ validations: validationRules });

    const handleChange = (event) => {
        const value = event.target.value;
        handleInput(event);

        onChange(event, value, formErrors[name]?.value);
    }

    const handleBlur = (event) => {
        const value = event.target.value;
        handleInput(event);

        onBlur(event, value, formErrors[name]?.value);
    }

    const handleSubmit = (event) => {
        const formValid = handleForm(event);

        if (formValid.value) {
            onSubmit(event);
        }
    }

    return (
        <div className={'mybswh-email-form-container'}>
            <div className="mybswh-email-form">
                {/*<div className="mybswh-email-form__shadow"></div>*/}
                <EmailAddress
                    {...inputProps}
                    disabled={disabled}
                    error={formErrors[name]?.value}
                    hintMsg={formErrors[name]?.message ? formErrors[name]?.message : hintMsg}
                    id={id || name}
                    label={label}
                    name={name}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    required={required}
                    value={value}
                />
                <div className="mybswh-email-form__submit-btn">
                    <CircleButton
                        icon="arrow"
                        colorStyle="accent"
                        disabled={disabled ? disabled : formErrors[name]?.value}
                        onClick={handleSubmit}
                    />
                </div>
            </div>
        </div>
    )
}

EmailForm.propTypes = {
    customValidation: PropTypes.func, // Function for extra custom validation
    disabled: PropTypes.bool,         // Disable input
    errorMsg: PropTypes.string,       // Input inline error message
    hintMsg: PropTypes.oneOfType([    // Input inline hint message
        PropTypes.string,
        PropTypes.object,
    ]),        
    id: PropTypes.string,             // Input id
    label: PropTypes.string,          // Input label
    name: PropTypes.string,           // Input name
    onBlur: PropTypes.func,           // Invoked each input blur event
    onChange: PropTypes.func,         // Invoked every time the user changes the input's value.
    onSubmit: PropTypes.func,         // Invoked when user submits valid form 
    pattern: PropTypes.string,        // Custom pattern validation that overrides default email address pattern
    required: PropTypes.bool,         // Set to true so input empty validation check will trigger on blur and change
    value: PropTypes.string           // Input value
}
